/**
 * @generated SignedSource<<659dae786f5d8048daf5a36b638e7045>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entityDisabled",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schedulable",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
    }, v9 = [
        (v2 /*: any*/)
    ], v10 = {
        "kind": "InlineFragment",
        "selections": (v9 /*: any*/),
        "type": "Node",
        "abstractKey": "__isNode"
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employeeId",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedEntityId",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    }, v15 = [
        (v2 /*: any*/),
        (v14 /*: any*/)
    ], v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "end",
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "start",
        "storageKey": null
    }, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVacant",
        "storageKey": null
    }, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    }, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignmentTypeId",
        "storageKey": null
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/),
            (v11 /*: any*/)
        ],
        "type": "ISchedulableEntity",
        "abstractKey": "__isISchedulableEntity"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": (v9 /*: any*/),
                "storageKey": null
            }
        ],
        "type": "SchedulableUser",
        "abstractKey": null
    }, v23 = [
        (v14 /*: any*/),
        (v2 /*: any*/)
    ], v24 = {
        "alias": null,
        "args": null,
        "concreteType": "ScheduleShiftAssetValidation",
        "kind": "LinkedField",
        "name": "assetValidations",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "SchedulableAsset",
                "kind": "LinkedField",
                "name": "schedulableAsset",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "asset",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/),
                            (v5 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "assetNumber",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "validateProficiency",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    (v2 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "SchedulableUser",
                "kind": "LinkedField",
                "name": "schedulableUser",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            (v8 /*: any*/),
                            (v2 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v2 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "AssignmentType",
                "kind": "LinkedField",
                "name": "userAssignmentType",
                "plural": false,
                "selections": (v23 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "AssetProficiencyValidation",
                "kind": "LinkedField",
                "name": "assetProficiency",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isValid",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    }, v26 = [
        (v5 /*: any*/),
        (v2 /*: any*/)
    ], v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    }, v28 = {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v29 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    }, v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timestamp",
        "storageKey": null
    }, v31 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
    }, v32 = [
        {
            "kind": "Literal",
            "name": "order",
            "value": {
                "timestamp": "DESC"
            }
        }
    ], v33 = {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "byUser",
        "plural": false,
        "selections": [
            (v12 /*: any*/),
            (v8 /*: any*/),
            (v2 /*: any*/)
        ],
        "storageKey": null
    }, v34 = {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "reasonEvent",
        "plural": false,
        "selections": (v26 /*: any*/),
        "storageKey": null
    }, v35 = [
        (v3 /*: any*/),
        {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isSchedulableEntity"
        },
        (v21 /*: any*/),
        (v10 /*: any*/)
    ], v36 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "newAssignedEntity",
        "plural": false,
        "selections": (v35 /*: any*/),
        "storageKey": null
    }, v37 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "previouslyAssignedEntity",
        "plural": false,
        "selections": (v35 /*: any*/),
        "storageKey": null
    }, v38 = [
        (v17 /*: any*/),
        (v16 /*: any*/),
        (v29 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpdateAssignedEntityOnShiftMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateScheduleShiftAssigneePayload",
                    "kind": "LinkedField",
                    "name": "updateScheduleShiftAssignee",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfScheduleShiftHistoryAssigneeChange",
                            "kind": "LinkedField",
                            "name": "scheduleShiftHistoryAssigneeChangeEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleShiftHistoryAssigneeChange",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleShift",
                                            "kind": "LinkedField",
                                            "name": "scheduleShift",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "ScheduleShift_shift"
                                                },
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "ScheduleShiftInformationTab_ScheduleShift"
                                                },
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "ScheduleShiftHistory_scheduleShift"
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleShiftHistoryAssigneeChange_history"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpdateAssignedEntityOnShiftMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateScheduleShiftAssigneePayload",
                    "kind": "LinkedField",
                    "name": "updateScheduleShiftAssignee",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfScheduleShiftHistoryAssigneeChange",
                            "kind": "LinkedField",
                            "name": "scheduleShiftHistoryAssigneeChangeEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleShiftHistoryAssigneeChange",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleShift",
                                            "kind": "LinkedField",
                                            "name": "scheduleShift",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "assignedEntity",
                                                    "plural": false,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Asset",
                                                                    "kind": "LinkedField",
                                                                    "name": "asset",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v4 /*: any*/),
                                                                        (v5 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v6 /*: any*/),
                                                                (v7 /*: any*/)
                                                            ],
                                                            "type": "SchedulableAsset",
                                                            "abstractKey": null
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v6 /*: any*/),
                                                                (v7 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v4 /*: any*/),
                                                                        (v8 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "SchedulableUser",
                                                            "abstractKey": null
                                                        },
                                                        (v10 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "User",
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "phone",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v12 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SchedulableUser",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "type": "ISchedulableEntity",
                                                            "abstractKey": "__isISchedulableEntity"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v13 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AssignmentType",
                                                    "kind": "LinkedField",
                                                    "name": "assignmentType",
                                                    "plural": false,
                                                    "selections": (v15 /*: any*/),
                                                    "storageKey": null
                                                },
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                (v18 /*: any*/),
                                                (v19 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "event",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isWork",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isAbsence",
                                                            "storageKey": null
                                                        },
                                                        (v5 /*: any*/),
                                                        (v4 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Schedule",
                                                    "kind": "LinkedField",
                                                    "name": "schedule",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "currentUserPermissions",
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleAssignmentTypeConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignmentTypes",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleAssignmentTypeEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ScheduleAssignmentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v20 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ScheduleAssignmentTypeResourceConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "resources",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "ScheduleAssignmentTypeResourceEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "ScheduleAssignmentTypeResource",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": null,
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "schedulableEntity",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                (v3 /*: any*/),
                                                                                                                (v21 /*: any*/),
                                                                                                                (v10 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v2 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleAssignmentType",
                                                    "kind": "LinkedField",
                                                    "name": "scheduleAssignmentType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "where",
                                                                    "value": {
                                                                        "schedulableEntity": {
                                                                            "type": {
                                                                                "eq": "USER"
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            ],
                                                            "concreteType": "ScheduleAssignmentTypeResourceConnection",
                                                            "kind": "LinkedField",
                                                            "name": "resources",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleAssignmentTypeResource",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": null,
                                                                            "kind": "LinkedField",
                                                                            "name": "schedulableEntity",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v3 /*: any*/),
                                                                                (v22 /*: any*/),
                                                                                (v10 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v2 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "resources(where:{\"schedulableEntity\":{\"type\":{\"eq\":\"USER\"}}})"
                                                        },
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v20 /*: any*/),
                                                (v24 /*: any*/),
                                                (v25 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ITaggedItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "tags",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ITaggedItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        (v2 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "tagId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Tag",
                                                                            "kind": "LinkedField",
                                                                            "name": "tag",
                                                                            "plural": false,
                                                                            "selections": (v26 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v27 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v28 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "filters": null,
                                                    "handle": "connection",
                                                    "key": "useScheduleShiftTags_tags",
                                                    "kind": "LinkedHandle",
                                                    "name": "tags"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Break",
                                                    "kind": "LinkedField",
                                                    "name": "breaks",
                                                    "plural": true,
                                                    "selections": [
                                                        (v16 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v29 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleShiftConnection",
                                                    "kind": "LinkedField",
                                                    "name": "simultaneousScheduleShift",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleShiftEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleShift",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": null,
                                                                            "kind": "LinkedField",
                                                                            "name": "assignedEntity",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v3 /*: any*/),
                                                                                (v22 /*: any*/),
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Asset",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "asset",
                                                                                            "plural": false,
                                                                                            "selections": (v9 /*: any*/),
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "type": "SchedulableAsset",
                                                                                    "abstractKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        (v2 /*: any*/),
                                                                                        (v11 /*: any*/),
                                                                                        (v4 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "User",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v12 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SchedulableUser",
                                                                                            "abstractKey": null
                                                                                        }
                                                                                    ],
                                                                                    "type": "ISchedulableEntity",
                                                                                    "abstractKey": "__isISchedulableEntity"
                                                                                },
                                                                                (v10 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "AssignmentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "assignmentType",
                                                                            "plural": false,
                                                                            "selections": (v23 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        (v16 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v19 /*: any*/),
                                                                        (v24 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "IFileConnection",
                                                    "kind": "LinkedField",
                                                    "name": "attachments",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "IFileEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "contentType",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "directory",
                                                                            "storageKey": null
                                                                        },
                                                                        (v2 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "size",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "storageId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "url",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v27 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v28 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "filters": null,
                                                    "handle": "connection",
                                                    "key": "useScheduleShiftAttachments_attachments",
                                                    "kind": "LinkedHandle",
                                                    "name": "attachments"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleShiftHistoryVacancyInterest",
                                                    "kind": "LinkedField",
                                                    "name": "currentVacancyInterestForEntity",
                                                    "plural": false,
                                                    "selections": [
                                                        (v25 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleShiftHistoryVacancyInterestConnection",
                                                    "kind": "LinkedField",
                                                    "name": "vacancyInterests",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleShiftHistoryVacancyInterest",
                                                            "kind": "LinkedField",
                                                            "name": "nodes",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "kind": "LinkedField",
                                                                    "name": "byUser",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Avatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "queryTransform",
                                                                                                    "value": "width=300&height=300&mode=crop&scale=both"
                                                                                                }
                                                                                            ],
                                                                                            "kind": "ScalarField",
                                                                                            "name": "url",
                                                                                            "storageKey": "url(queryTransform:\"width=300&height=300&mode=crop&scale=both\")"
                                                                                        },
                                                                                        (v2 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        (v4 /*: any*/),
                                                                                        (v5 /*: any*/)
                                                                                    ],
                                                                                    "type": "Asset",
                                                                                    "abstractKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        (v5 /*: any*/)
                                                                                    ],
                                                                                    "type": "Company",
                                                                                    "abstractKey": null
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        (v4 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "firstname",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "lastname",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "type": "User",
                                                                                    "abstractKey": null
                                                                                }
                                                                            ],
                                                                            "type": "IHaveAvatar",
                                                                            "abstractKey": "__isIHaveAvatar"
                                                                        },
                                                                        (v12 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        (v2 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v2 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "schedulableEntityId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleShift",
                                                                    "kind": "LinkedField",
                                                                    "name": "scheduleShift",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v13 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v19 /*: any*/),
                                                                (v30 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v31 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v32 /*: any*/),
                                                    "concreteType": "ScheduleShiftHistoryConnection",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleShiftHistoryEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v3 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v30 /*: any*/),
                                                                                (v25 /*: any*/),
                                                                                (v29 /*: any*/),
                                                                                (v33 /*: any*/)
                                                                            ],
                                                                            "type": "IHaveScheduleShiftHistory",
                                                                            "abstractKey": "__isIHaveScheduleShiftHistory"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "AssignmentType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "newAssignmentType",
                                                                                    "plural": false,
                                                                                    "selections": (v15 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "AssignmentType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "previousAssignmentType",
                                                                                    "plural": false,
                                                                                    "selections": (v15 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "ScheduleShiftHistoryAssignmentTypeChange",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v34 /*: any*/),
                                                                                (v33 /*: any*/),
                                                                                (v36 /*: any*/),
                                                                                (v37 /*: any*/),
                                                                                (v30 /*: any*/)
                                                                            ],
                                                                            "type": "ScheduleShiftHistoryAssigneeChange",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v33 /*: any*/),
                                                                                (v25 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "schedulableEntity",
                                                                                    "plural": false,
                                                                                    "selections": (v35 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                (v19 /*: any*/),
                                                                                (v30 /*: any*/)
                                                                            ],
                                                                            "type": "ScheduleShiftHistoryVacancyInterest",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v33 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "newEnd",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "newStart",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Break",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "originalBreaks",
                                                                                    "plural": true,
                                                                                    "selections": (v38 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Break",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "newBreaks",
                                                                                    "plural": true,
                                                                                    "selections": (v38 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "originalEnd",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "originalStart",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v30 /*: any*/)
                                                                            ],
                                                                            "type": "ScheduleShiftHistoryTimeChange",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Event",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "newEvent",
                                                                                    "plural": false,
                                                                                    "selections": (v26 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Event",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "previousEvent",
                                                                                    "plural": false,
                                                                                    "selections": (v26 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                (v33 /*: any*/),
                                                                                (v30 /*: any*/)
                                                                            ],
                                                                            "type": "ScheduleShiftHistoryEventChange",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "newStatus",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "previousStatus",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v33 /*: any*/),
                                                                                (v30 /*: any*/)
                                                                            ],
                                                                            "type": "ScheduleShiftHistoryStatusChange",
                                                                            "abstractKey": null
                                                                        },
                                                                        (v10 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v27 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v31 /*: any*/),
                                                        (v28 /*: any*/)
                                                    ],
                                                    "storageKey": "history(order:{\"timestamp\":\"DESC\"})"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v32 /*: any*/),
                                                    "filters": [
                                                        "order"
                                                    ],
                                                    "handle": "connection",
                                                    "key": "ScheduleShiftHistory_history",
                                                    "kind": "LinkedHandle",
                                                    "name": "history"
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v34 /*: any*/),
                                        (v33 /*: any*/),
                                        (v36 /*: any*/),
                                        (v37 /*: any*/),
                                        (v30 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "248c118ce66ee1980cb0ac051ef6fcb6",
            "id": null,
            "metadata": {},
            "name": "UpdateAssignedEntityOnShiftMutation",
            "operationKind": "mutation",
            "text": "mutation UpdateAssignedEntityOnShiftMutation(\n  $model: UpdateScheduleShiftAssigneeRequestInput!\n) {\n  updateScheduleShiftAssignee(model: $model) {\n    scheduleShiftHistoryAssigneeChangeEdge {\n      node {\n        id\n        scheduleShift {\n          ...ScheduleShift_shift\n          ...ScheduleShiftInformationTab_ScheduleShift\n          ...ScheduleShiftHistory_scheduleShift\n          id\n        }\n        ...ScheduleShiftHistoryAssigneeChange_history\n      }\n    }\n  }\n}\n\nfragment AssetProficiencyValidationIcon_scheduleShiftAssetValidation on ScheduleShiftAssetValidation {\n  schedulableAsset {\n    asset {\n      id\n      name\n      assetNumber\n      validateProficiency\n    }\n    id\n  }\n  schedulableUser {\n    user {\n      fullName\n      id\n    }\n    id\n  }\n  userAssignmentType {\n    title\n    id\n  }\n  assetProficiency {\n    isValid\n  }\n}\n\nfragment AssignedEntity_ScheduleShift on ScheduleShift {\n  id\n  assignedEntity {\n    __typename\n    ... on ISchedulableEntity {\n      __isISchedulableEntity: __typename\n      id\n      displayName\n      color\n      ... on SchedulableUser {\n        user {\n          phone\n          employeeId\n          id\n        }\n      }\n    }\n    ...SchedulableEntityWithText_iScheduleableEntity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  scheduleAssignmentType {\n    resources(where: {schedulableEntity: {type: {eq: USER}}}) {\n      nodes {\n        schedulableEntity {\n          __typename\n          ... on SchedulableUser {\n            user {\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n  schedule {\n    currentUserPermissions\n    id\n  }\n  ...RemoveAssignedEntity\n  ...UpdateAssignedEntityOnShift_scheduleShift\n  isVacant\n  status\n  ...ScheduleShiftAssetValidations_scheduleShift\n}\n\nfragment Avatar_iHaveAvatar on IHaveAvatar {\n  __isIHaveAvatar: __typename\n  avatar {\n    url(queryTransform: \"width=300&height=300&mode=crop&scale=both\")\n    id\n  }\n  ... on Asset {\n    color\n    name\n  }\n  ... on Company {\n    name\n  }\n  ... on User {\n    color\n    firstname\n    lastname\n  }\n}\n\nfragment EditScheduleShiftDescription on ScheduleShift {\n  id\n  description\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment EditScheduleShiftEvent on ScheduleShift {\n  id\n  assignmentTypeId\n  event {\n    id\n    name\n  }\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment EditScheduleShiftTimeEnd on ScheduleShift {\n  id\n  end\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment EditScheduleShiftTimeStart on ScheduleShift {\n  id\n  schedule {\n    currentUserPermissions\n    id\n  }\n  start\n}\n\nfragment RemoveAssignedEntity on ScheduleShift {\n  id\n  assignmentType {\n    title\n    id\n  }\n}\n\nfragment SchedulableAsset_entity on SchedulableAsset {\n  id\n  asset {\n    id\n    color\n    name\n  }\n  entityDisabled\n  schedulable\n}\n\nfragment SchedulableEntityWithText_iScheduleableEntity on ISchedulableEntity {\n  __isISchedulableEntity: __typename\n  id\n  displayName\n  color\n  ... on SchedulableUser {\n    user {\n      employeeId\n      id\n    }\n  }\n}\n\nfragment SchedulableEntity_schedulableEntity on SchedulableEntity {\n  __isSchedulableEntity: __typename\n  ... on ISchedulableEntity {\n    __isISchedulableEntity: __typename\n    id\n    displayName\n  }\n}\n\nfragment SchedulableUser_entity on SchedulableUser {\n  id\n  entityDisabled\n  schedulable\n  user {\n    id\n    color\n    fullName\n  }\n}\n\nfragment ScheduleShiftAssetValidations_scheduleShift on ScheduleShift {\n  assetValidations {\n    ...AssetProficiencyValidationIcon_scheduleShiftAssetValidation\n    schedulableAsset {\n      asset {\n        validateProficiency\n        id\n      }\n      id\n    }\n    assetProficiency {\n      isValid\n    }\n  }\n}\n\nfragment ScheduleShiftEditBreaks_scheduleShift on ScheduleShift {\n  start\n  id\n  end\n  breaks {\n    end\n    start\n    type\n  }\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment ScheduleShiftFiles_scheduleShift on ScheduleShift {\n  ...useScheduleShiftAttachments_scheduleShift\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment ScheduleShiftHistoryAssigneeChange_history on ScheduleShiftHistoryAssigneeChange {\n  id\n  reasonEvent {\n    name\n    id\n  }\n  byUser {\n    ...User_user\n    id\n  }\n  newAssignedEntity {\n    __typename\n    ...SchedulableEntity_schedulableEntity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  previouslyAssignedEntity {\n    __typename\n    ...SchedulableEntity_schedulableEntity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  timestamp\n}\n\nfragment ScheduleShiftHistoryEventChange_history on ScheduleShiftHistoryEventChange {\n  id\n  newEvent {\n    name\n    id\n  }\n  previousEvent {\n    name\n    id\n  }\n  byUser {\n    ...User_user\n    id\n  }\n  timestamp\n}\n\nfragment ScheduleShiftHistoryStatusChange_history on ScheduleShiftHistoryStatusChange {\n  id\n  newStatus\n  previousStatus\n  byUser {\n    ...User_user\n    id\n  }\n  timestamp\n}\n\nfragment ScheduleShiftHistoryTimeChange_history on ScheduleShiftHistoryTimeChange {\n  id\n  byUser {\n    ...User_user\n    id\n  }\n  newEnd\n  newStart\n  originalBreaks {\n    start\n    end\n    type\n  }\n  newBreaks {\n    start\n    end\n    type\n  }\n  originalEnd\n  originalStart\n  timestamp\n}\n\nfragment ScheduleShiftHistoryVacancyInterestListItem_scheduleShiftHistoryVacancyInterest on ScheduleShiftHistoryVacancyInterest {\n  byUser {\n    ...UserSnippet_user\n    id\n  }\n  id\n  schedulableEntityId\n  scheduleShift {\n    id\n    assignedEntityId\n  }\n  status\n  timestamp\n}\n\nfragment ScheduleShiftHistoryVacancyInterestList_scheduleShiftHistoryVacancyInterestConnection on ScheduleShiftHistoryVacancyInterestConnection {\n  nodes {\n    ...ScheduleShiftHistoryVacancyInterestListItem_scheduleShiftHistoryVacancyInterest\n    id\n  }\n  totalCount\n}\n\nfragment ScheduleShiftHistoryVacancyInterest_history on ScheduleShiftHistoryVacancyInterest {\n  id\n  byUser {\n    ...User_user\n    id\n  }\n  description\n  schedulableEntity {\n    __typename\n    ...SchedulableEntity_schedulableEntity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  status\n  timestamp\n}\n\nfragment ScheduleShiftHistory_scheduleShift on ScheduleShift {\n  id\n  history(order: {timestamp: DESC}) {\n    edges {\n      node {\n        __typename\n        ... on IHaveScheduleShiftHistory {\n          __isIHaveScheduleShiftHistory: __typename\n          id\n          timestamp\n          description\n          type\n          byUser {\n            ...User_user\n            id\n          }\n        }\n        ... on ScheduleShiftHistoryAssignmentTypeChange {\n          newAssignmentType {\n            id\n            title\n          }\n          previousAssignmentType {\n            id\n            title\n          }\n        }\n        ...ScheduleShiftHistoryAssigneeChange_history\n        ...ScheduleShiftHistoryVacancyInterest_history\n        ...ScheduleShiftHistoryTimeChange_history\n        ...ScheduleShiftHistoryEventChange_history\n        ...ScheduleShiftHistoryStatusChange_history\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScheduleShiftInformationTab_ScheduleShift on ScheduleShift {\n  id\n  schedule {\n    currentUserPermissions\n    id\n  }\n  ...AssignedEntity_ScheduleShift\n  ...ShiftInformation_ScheduleShift\n  ...SimultaneousShifts_scheduleShift\n  ...ScheduleShiftFiles_scheduleShift\n  ...ScheduleShiftInterestForm_scheduleShift\n  isVacant\n  status\n  vacancyInterests {\n    ...ScheduleShiftHistoryVacancyInterestList_scheduleShiftHistoryVacancyInterestConnection\n  }\n}\n\nfragment ScheduleShiftInterestForm_scheduleShift on ScheduleShift {\n  id\n  currentVacancyInterestForEntity {\n    description\n    status\n    id\n  }\n}\n\nfragment ScheduleShift_shift on ScheduleShift {\n  id\n  assignedEntity {\n    ... on SchedulableAsset {\n      id\n      ...SchedulableAsset_entity\n    }\n    ... on SchedulableUser {\n      id\n      ...SchedulableUser_entity\n    }\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  assignedEntityId\n  assignmentType {\n    id\n    title\n  }\n  end\n  start\n  isVacant\n  status\n  event {\n    id\n    isWork\n    isAbsence\n    name\n    color\n  }\n}\n\nfragment ShiftInformation_ScheduleShift on ScheduleShift {\n  ...EditScheduleShiftTimeStart\n  ...EditScheduleShiftTimeEnd\n  ...EditScheduleShiftEvent\n  ...EditScheduleShiftDescription\n  ...useScheduleShiftTags_scheduleShift\n  ...ScheduleShiftEditBreaks_scheduleShift\n  assignmentTypeId\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment SimultaneousShifts_scheduleShift on ScheduleShift {\n  simultaneousScheduleShift {\n    edges {\n      node {\n        id\n        assignedEntity {\n          __typename\n          ... on SchedulableUser {\n            user {\n              id\n            }\n          }\n          ... on SchedulableAsset {\n            asset {\n              id\n            }\n          }\n          ...SchedulableEntityWithText_iScheduleableEntity\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        assignmentType {\n          title\n          id\n        }\n        end\n        start\n        isVacant\n        status\n        ...ScheduleShiftAssetValidations_scheduleShift\n      }\n    }\n  }\n}\n\nfragment UpdateAssignedEntityOnShift_scheduleShift on ScheduleShift {\n  id\n  assignedEntityId\n  start\n  end\n  assignmentTypeId\n  assignmentType {\n    title\n    id\n  }\n  schedule {\n    assignmentTypes {\n      edges {\n        node {\n          id\n          assignmentTypeId\n          resources {\n            edges {\n              node {\n                schedulableEntity {\n                  __typename\n                  ... on ISchedulableEntity {\n                    __isISchedulableEntity: __typename\n                    id\n                    displayName\n                  }\n                  ... on Node {\n                    __isNode: __typename\n                    id\n                  }\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment UserNameLabel_user on User {\n  employeeId\n  fullName\n}\n\nfragment UserSnippet_user on User {\n  ...Avatar_iHaveAvatar\n  ...UserNameLabel_user\n  id\n}\n\nfragment User_user on User {\n  ...UserNameLabel_user\n  id\n}\n\nfragment useScheduleShiftAttachments_scheduleShift on ScheduleShift {\n  id\n  attachments {\n    edges {\n      node {\n        __typename\n        contentType\n        directory\n        id\n        name\n        size\n        storageId\n        url\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useScheduleShiftTags_scheduleShift on ScheduleShift {\n  id\n  tags {\n    edges {\n      node {\n        __typename\n        id\n        tagId\n        tag {\n          name\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "2cf256951065b07a8aa172a422e8d105";
export default node;
